module.exports = __webpack_public_path__ + "static/media/bazaarjumbotron.ca31a5ff.mp4";